'use strict';



function ___$insertStyle(css) {
  if (!css) {
    return;
  }
  if (typeof window === 'undefined') {
    return;
  }

  var style = document.createElement('style');

  style.setAttribute('type', 'text/css');
  style.innerHTML = css;
  document.head.appendChild(style);
  return css;
}

Object.defineProperty(exports, '__esModule', { value: true });

var formatPhoneNumber = function (phone) {
    var p1 = phone.substring(0, 3);
    var p2 = phone.substring(3, 6);
    var p3 = phone.substring(6, 10);
    var p4 = phone.substring(10, 14);
    var p5 = phone.substring(14);
    var number = '';
    if (p1) {
        number += p1;
    }
    if (p2) {
        number += " " + p2;
    }
    if (p3) {
        number += " " + p3;
    }
    if (p4) {
        number += " " + p4;
    }
    if (p5) {
        number += " " + p5;
    }
    return number;
};
var idnPhoneNumber = function (num) {
    var phone = num;
    var format = num.replace(/[^\d.-]/g, '');
    if (format === '' || format === '62') {
        return '';
    }
    else if (phone.length <= 19) {
        if (phone.substring(0, 2) !== '+62') {
            if (num.substring(0, 3) === '+62') {
                format = format.slice(2);
            }
            if (num.substring(0, 1) === '0') {
                format = format.slice(1);
            }
            phone = "+62" + format;
        }
        else {
            phone = "+62" + num.slice(5).replace(/[^\d.-]/g, '');
        }
        return formatPhoneNumber(phone);
    }
};
var handlePhoneNumber = function (phone) {
    return {
        idn: idnPhoneNumber(phone),
        format: phone,
        number: phone.split(' ').join('').replace('+62', '0'),
        value: phone.split(' ').join(''),
    };
};
var idnPhoneValidation = function (phone) {
    var phoneNumber = phone.replace(/\s/g, '');
    var validNumber = /^(^\8)(\d{3,4}-?){2}\d{3,4}$/;
    if (!phoneNumber.match(validNumber)) {
        return false;
    }
    return true;
};

exports.formatPhoneNumber = formatPhoneNumber;
exports.handlePhoneNumber = handlePhoneNumber;
exports.idnPhoneNumber = idnPhoneNumber;
exports.idnPhoneValidation = idnPhoneValidation;
//# sourceMappingURL=handlePhoneNumber.js.map
